module.exports = __webpack_public_path__ + "img/MatchedFilter1.5d181b8d.png";